import { rgba } from 'polished';
import {
  sideNavBaseStyle,
  TSideNavTheme,
} from '../../base/customComponents/sideNav';
import { TStyleConfig } from '../../base/types';

export const SideNav: TStyleConfig<TSideNavTheme> = {
  baseStyle: (props) => {
    const base = sideNavBaseStyle(props);

    return {
      ...base,
      readableColor: 'white',
      borderBottom: 'white',
      bottomBorderRadius: base.borderBottomRadius,
      background: {
        bgGradient: [
          'linear(to-b, alpha.700, alpha.800)',
          null,
          'linear(to-b, white, white)',
        ],
        boxShadow: 'lg',
        borderRadius: [null, null, null, 'md'],
        alignSelf: [null, null, null, 'flex-start'],
        overflow: 'hidden',
        mt: ['53px', '110px', null, '0px'],
        mb: '3',
      },
      drawer: {
        ...base.drawer,
      },
      drawerBody: {
        '> div, a': {
          ml: ['0', null, '2'],

          '> .dropDownInner, a[class*="dropDownInner"]': {
            _first: {
              borderColor: 'transparent',
              cursor: 'initial',
            },
            '&:hover, &:active': {
              bg: rgba(`${props.theme.colors.beta[500]}`, 0.8),
            },
          },
        },
      },
      icon: {
        ...base.icon,
        boxSize: '20px',
        color: ['white', null, 'alpha.700'],
      },
      headerSX: {
        cursor: 'default',
        color: ['white', null, 'alpha.700'],
        height: '45px',
        borderColor: 'transparent',
        '&:hover': {
          borderColor: 'transparent',
          bg: 'transparent',
        },
      },
      dropDownInner: {
        ...base.dropDownInner,
        color: 'white',
        px: '4',
      },
      linkSX: {
        ...base.linkSX,
      },
      link: {
        ...base.link,

        fontSize: 'sm',
        fontWeight: 'bold',
        height: '43px',
        color: ['white', null, 'alpha.700'],
        transition: 'all, 0.2s linear',
        borderLeftWidth: '3px',
        borderLeftColor: 'transparent',

        borderBottomWidth: '1px',
        borderBottomColor: ['transparent', null, 'gray.200'],
        p: '4',
        ml: '0',

        '~ .nested': {
          pl: '10',
        },

        ':hover': {
          borderLeftColor: 'alpha.600',
          borderBottomColor: 'transparent',
          bg: ['transparent', null, 'alpha.50'],
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          transition: 'all, 0.2s linear',
        },
      },

      dropDownContainerClosed: {
        '.dropDownInner': {
          pl: ['4', null, '4'],
        },

        '> a, .dropDownIcon, a': {
          color: ['white', null, 'alpha.700'],
        },

        '&:hover, &:active': {
          color: 'alpha.700',

          '.dropDownInner': {
            ...base.dropDownInner,
            px: '4',
            color: ['white', null, 'alpha.700'],
          },

          '.svgIcon, .icon': {
            color: ['white', null, 'alpha.700'],
          },
        },
      },
      dropDownContainerOpen: {
        ...base.dropDownContainerOpen,

        p: '0',
        color: ['white', null, 'red.700'],

        _hover: {
          '.dropDownInner': {
            bg: 'alpha.600',
          },
        },

        '.dropDownInner': {
          bg: 'alpha.600',
          color: 'white',
          borderLeftWidth: '3px',
          borderColor: 'alpha.600',
        },

        '> a, .dropDownIcon, a': {
          color: 'white',
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          color: 'white',
        },
      },
    };
  },
  sizes: {},
  variants: {},
};
